import { render, staticRenderFns } from "./call_screen_pop.vue?vue&type=template&id=f5155548&"
import script from "./call_screen_pop.vue?vue&type=script&lang=js&"
export * from "./call_screen_pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports